module.exports = __webpack_public_path__ + "img/project-management.03e3f247.png";